var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 176 176",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.162 53.452c-4.409-10.4227-10.718-19.7819-18.754-27.8176-8.036-8.0358-17.395-14.3455-27.818-18.75393-10.794-4.56543-22.2564-6.88047-34.0691-6.88047-11.8125 0-23.275 2.31485-34.0689 6.88047-10.4227 4.40843-19.7819 10.71813-27.8176 18.75393-8.0358 8.0357-14.3455 17.3949-18.75393 27.8176-4.56543 10.7939-6.88047 22.2564-6.88047 34.0689s2.31485 23.2751 6.88047 34.0691c4.40843 10.423 10.71813 19.782 18.75393 27.818 8.0357 8.036 17.3949 14.345 27.8176 18.754 10.7939 4.565 22.2564 6.88 34.0689 6.88s23.2751-2.315 34.0691-6.88c10.423-4.409 19.782-10.718 27.818-18.754s14.345-17.395 18.754-27.818c4.565-10.794 6.88-22.2564 6.88-34.0691 0-11.8125-2.315-23.275-6.88-34.0689zm-80.6411 114.71c-41.3666 0-80.64043-39.274-80.64043-80.6411 0-41.3666 39.27403-80.64043 80.64063-80.64043 41.3669 0 80.6409 39.27383 80.6409 80.64043 0 41.3671-39.274 80.6411-80.6411 80.6411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.127 62.9248h10.0341l22.6685 40.9062v-40.9062h7.727v52.0752h-10.0341l-22.6685-40.3564v40.3564h-7.727zm50.6835 0h34.8635v7.6904h-27.1364v44.3848h-7.7271zm12.1216 21.1304h22.7419v7.6904h-22.7419zm28.6009-21.1304h42.407v7.6904h-17.321v44.3848h-7.764v-44.3848h-17.322z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.c6e3f836992eeb44a254700684f748e6.svg";
export { ForwardRef as ReactComponent };